import { useI18n } from 'vue-i18n'

import { AppointmentActionEnum, AppointmentStateEnum, useMeetingsUpdateAppointmentStatusMutation } from '@/gql/myomr'

import { useMeetingsBase } from './useMeetingsBase'

export { type AppointmentNode } from './useMeetingsBase'

export function useMeetingsMyMeetings() {
  const { t } = useI18n()
  const base = useMeetingsBase([AppointmentStateEnum.Approved])
  const { mutate: updateAppointmentStatus } = useMeetingsUpdateAppointmentStatusMutation()

  async function cancelMeeting(appointmentId: string, cancellationReason?: string): Promise<boolean> {
    try {
      const result = await updateAppointmentStatus({
        calendarAppointmentId: appointmentId,
        action: AppointmentActionEnum.Cancel,
        cancellationReason,
      })

      if (result?.data?.meetingsUpdateAppointmentStatus?.errors?.length) {
        result.data.meetingsUpdateAppointmentStatus.errors.forEach((error) => {
          if (error) base.showToast(error, 'error')
        })
        return false
      }

      base.showToast(t('Meetings.myMeetings.meetingCancelled'), 'success')
      await base.refetch()
      base.refetchCounters()
      return true
    } catch (_error) {
      base.showToast(t('common.errorOccurred'), 'error')
      return false
    }
  }

  return {
    ...base,
    cancelMeeting,
  }
}
